import React from 'react'
import styled from 'styled-components'
import { useTotalSupply2, useBurnedBalance } from 'hooks/useTokenBalance'
import { getCakeAddress, getHVIAddress } from 'utils/addressHelpers'
import { getBalanceNumber, formatLocalisedCompactNumber } from 'utils/formatBalance'
import { usePriceHVIBusd} from 'state/farms/hooks'
import { Flex, Text, Box, Skeleton, Image, Button , MetamaskIcon} from '@pancakeswap/uikit'
import { registerToken } from 'utils/wallet'
import { useTranslation } from 'contexts/Localization'
import Balance from 'components/Balance'

const StyledColumn = styled(Flex)<{ noMobileBorder?: boolean }>`
  flex-direction: column;
  margin-top: 10px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  ${({ noMobileBorder, theme }) =>
    noMobileBorder
      ? `${theme.mediaQueries.md} {
           padding: 0 16px;
           margin-top: 16px;
           margin-bottom: 16px;

         }
       `
      : `
         padding: 0 8px;
         ${theme.mediaQueries.sm} {
           padding: 0 16px;
           margin-top: 16px;
           align-items: center;
justify-content: center;
           margin-bottom: 16px;

         }
       `}
`
const ImageWrapper = styled(Box)`
position: relative;
top: 0;
left: 0;
margin-top: 0px;
margin-right: 27px;
margin-bottom: 15px;

img {
  max-height: 24px;
  min-width: 24px;
  min-height: 24px;
  min-width: 24px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    position: relative;
    margin-right: 35px;
    margin-bottom: 22px;
    top: 0;
    left: 0;
    img {
      max-height: 30px;
      min-width: 30px;
      min-height: 30px;
      min-width: 30px;
  
    }
`

const Grid = styled.div`
  display: grid;
  grid-gap: 16px 8px;
  margin-top: 24px;
  grid-template-columns: repeat(2, auto);

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-gap: 16px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-gap: 32px;
    grid-template-columns: repeat(4, auto);
  }
`

const emissionsPerBlock = 0.34

const CakeDataRow = () => {
  const { t } = useTranslation()
  const totalSupply = useTotalSupply2()
  const burnedBalance = getBalanceNumber(useBurnedBalance(getHVIAddress()))
  const cakeSupply = totalSupply ? getBalanceNumber(totalSupply) - burnedBalance : 0
  const cakePriceBusd = usePriceHVIBusd()
  const cakeSupply2 = totalSupply ? getBalanceNumber(totalSupply) : 0
  const mcap = cakePriceBusd.times(cakeSupply2).times(1000000000)
  const mcap2 = mcap.toNumber()
  const hvprice = cakePriceBusd.toNumber()

  const tokenAddress = "0xDE619A9E0eEeAA9F8CD39522Ed788234837F3B26"
  const symbol = "HVI"
  const decimals = "9"

  return (
    
      
      <Flex justifyContent="space-between" >
  
      <StyledColumn>
      <Flex alignItems="center" justifyContent="center" >
    <ImageWrapper>

    <Image
            src="/images/pixel/P1.png" 
            width={30}
            height={30}
          />
                </ImageWrapper>
                <Flex flexDirection="column">

        <Text fontSize="13px" color="textSubtle">{t('HVI')}</Text>
        <Text color="textSubtle">{t('')}</Text>
          {hvprice ? (
            <Balance decimals={15} fontSize="12px"  value={hvprice} prefix= "$" />
          ) : (
            <Skeleton height={18} width={126} />
          )}
          </Flex>
      </Flex>
      <Flex flexDirection="column"  >
    
   <Text color="textSubtle" fontSize="13px">{t('Total supply')}</Text>
        <Text color="textSubtle" fontSize="13px">{t('Circulation supply')}</Text>
        <Text color="textSubtle" fontSize="13px">{t('Burned')}</Text>
        <Text color="textSubtle" fontSize="13px">{t('Market cap')}</Text>
        </Flex>
      </StyledColumn>
      <StyledColumn>
      <Flex alignItems="center" justifyContent="center" mb="0px">
    <Button
              variant="text"
              p="0"
              height="auto"
              onClick={() => registerToken(tokenAddress, symbol, 9)}
            >
                    <Flex flexDirection="column">

               <MetamaskIcon  />
              <Text fontSize="12px"  color="primary">{t('Add to Metamask')}</Text>
              </Flex>
            </Button>
      </Flex>
      <Flex flexDirection="column"  mb="0px" >
      <Text color="textSubtle">{t('')}</Text>
          {cakeSupply ? (
            <Balance decimals={0} fontSize="13px"  value={cakeSupply2 * 1000000000} />
          ) : (
            <Skeleton height={18} width={126} my="4px" />
          )}
          <Text color="textSubtle">{t('')}</Text>
          {cakeSupply ? (
            <Balance decimals={0} fontSize="13px"  value={cakeSupply  * 1000000000} />
          ) : (
            <Skeleton height={18} width={126} my="4px" />
          )}
        </Flex>
          <Text color="textSubtle">{t('')}</Text>
          {burnedBalance ? (
            <Balance decimals={0} fontSize="13px"  value={burnedBalance  * 1000000000} />
          ) : (
            <Skeleton height={18} width={126} />
          )}
 <Text color="textSubtle">{t('')}</Text>
          {mcap2 ? (
            <Balance decimals={0} fontSize="13px"  value={ mcap2 } prefix="$" />
          ) : (
            <Skeleton height={18} width={126} my="4px" />
          )}
      
        </StyledColumn>
                </Flex>

  )
}

export default CakeDataRow
